"use client";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
export function Providers({children}:{children:React.ReactNode}) {
 return <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false}>{children}<Toaster position="bottom-center" offset={80} mobileOffset={80} /></ThemeProvider>;
}
